module.exports = __webpack_public_path__ + "static/media/vision.6081ad5f.gif";